/* eslint-disable react/jsx-pascal-case */
import styled from "styled-components";

import Logo_ㄱㄱ from "../image/live_commerce/Logo_ㄱㄱ2.png";
import theme, { Content_Text } from "../Component/theme";
import { useNavigate } from "react-router-dom";

const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
`;

const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  padding: 20px 0px;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
    margin-left: 15px;
  }
`;

const Top_Button = styled.span`
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  padding-left: 30px;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 20px 0px;
  margin-right: 20px;
  @media (max-width: 800px) {
    font-size: 12px;
  }
`;

const Header_Text = styled(Content_Text)`
  &:hover {
    color: black;
    transition: 0.5s;
  }
`;

const UnderLine = styled.div`
  position: absolute;
  bottom: -8px;
  width: 100%;
  height: 2px;
  background-color: black;
  @media (max-width: 800px) {
    height: 1px;
    bottom: 0px;
  }
`;

function Header_Live(route) {
  const navigation = useNavigate();

  const go_Home = () => {
    navigation("/Live_Commerce");
    window.scrollTo({ top: 0 });
  };
  const go_About = (item) => {
    navigation("/Live_Commerce/About", { state: { data: item } });
    window.scrollTo({ top: 0 });
  };
  const go_Info = () => {
    navigation("/Live_Commerce/Info");
    window.scrollTo({ top: 0 });
  };
  const go_Platform = () => {
    navigation("/Live_Commerce/Platform");
    window.scrollTo({ top: 0 });
  };
  const go_Process = () => {
    navigation("/Live_Commerce/Process");
    window.scrollTo({ top: 0 });
  };
  const go_Platform_Info = (item) => {
    navigation("/Live_Commerce/Platform_Info", { state: { data: item } });
    window.scrollTo({ top: 0 });
  };

  return (
    <Header_div>
      <Logo_img
        onClick={() => {
          go_Home();
        }}
        src={route.logo ? route.logo : Logo_ㄱㄱ}
        alt={Logo_ㄱㄱ}
      />
      <Top_Button
        onClick={() => {
          go_Info();
        }}
      >
        <Header_Text $lightGray={route.page !== "회사소개"}>
          회사소개
        </Header_Text>
        {route.page === "회사소개" && <UnderLine />}
      </Top_Button>
      <Top_Button
        onClick={() => {
          go_Process();
        }}
      >
        <Header_Text $lightGray={route.page !== "프로세스"}>
          프로세스
        </Header_Text>
        {route.page === "프로세스" && <UnderLine />}
      </Top_Button>
      <Top_Button
        onClick={() => {
          go_Platform();
        }}
      >
        <Header_Text $lightGray={route.page !== "플랫폼"}>플랫폼</Header_Text>
        {route.page === "플랫폼" && <UnderLine />}
      </Top_Button>
      <Top_Button
        onClick={() => {
          go_About();
        }}
      >
        <Header_Text $lightGray={route.page !== "제작문의"}>
          제작문의
        </Header_Text>
        {route.page === "제작문의" && <UnderLine />}
      </Top_Button>
    </Header_div>
  );
}

export default Header_Live;
